import { useEffect, useState } from 'react';

export default function HeroSection({ onOpenModal }: { onOpenModal: () => void }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 23,
    minutes: 59,
    seconds: 55
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) days--;
            }
          }
        }
        return { days, hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Workspace digital con gráficos de ventas y analítica"
          title="Productos digitales con inteligencia artificial"
          className="w-full h-full object-cover object-center"
          src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/16a4cc7c4e8b2783cef47c353b3a08bf.jpeg"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 py-16 sm:py-20 text-center">
        <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full mb-6 sm:mb-8 animate-pulse">
          <span className="w-2 h-2 bg-white rounded-full animate-ping flex-shrink-0"></span>
          <span className="text-[11px] sm:text-sm font-semibold tracking-wide uppercase leading-tight">
            ENTRENAMIENTO en vivo IA-Cash Express
          </span>
        </div>

        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-4 sm:mb-6 drop-shadow-2xl px-2">
          DESCUBRE CÓMO CREAR Y VENDER PRODUCTOS DIGITALES CON{' '}
          <span className="text-yellow-400">INTELIGENCIA ARTIFICIAL</span> EN{' '}
          <span className="text-yellow-400">MENOS DE 48 HORAS</span> 🚀
        </h1>

        <p className="text-sm sm:text-lg md:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed mb-8 sm:mb-10 px-2">
          No necesitas ser un experto ni saber programar. Te enseñamos a fabricar activos digitales de alta demanda y alta rentabilidad (90%+) que puedes cobrar hoy mismo en tu moneda local.{' '}
          <strong className="text-yellow-400 font-bold">
            Entrenamiento en Vivo: Del Cero al Producto Terminado en 1 sesión
          </strong>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 bg-black/50 backdrop-blur-sm px-4 sm:px-8 py-4 sm:py-5 rounded-2xl mb-6 sm:mb-8 border border-white/10 mx-2">
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line text-lg sm:text-2xl text-emerald-400 flex-shrink-0"></i>
            <span className="text-sm sm:text-xl font-semibold text-white">
              📅 PRÓXIMA CLASE: ESTA SEMANA
            </span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-white/20"></div>
          <div className="block sm:hidden w-16 h-px bg-white/20"></div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-lg sm:text-2xl text-emerald-400 flex-shrink-0"></i>
            <span className="text-sm sm:text-xl font-semibold text-white">
              8:00 PM (Perú 🇵🇪 / Colombia 🇨🇴)
            </span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 sm:gap-4 mb-8 sm:mb-10 px-2">
          {[
            { value: timeLeft.days, label: 'Días' },
            { value: timeLeft.hours, label: 'Horas' },
            { value: timeLeft.minutes, label: 'Min' },
            { value: timeLeft.seconds, label: 'Seg' },
          ].map((item, i) => (
            <>
              <div key={item.label} className="bg-gradient-to-br from-emerald-600 to-teal-700 rounded-xl sm:rounded-2xl p-2 sm:p-6 min-w-[58px] sm:min-w-[100px] shadow-2xl flex-1 max-w-[80px] sm:max-w-[120px]">
                <div className="text-xl sm:text-5xl font-bold text-white">
                  {String(item.value).padStart(2, '0')}
                </div>
                <div className="text-[9px] sm:text-xs text-gray-200 mt-1 sm:mt-2 uppercase tracking-wide">{item.label}</div>
              </div>
              {i < 3 && <div key={`sep-${i}`} className="text-lg sm:text-4xl text-white font-bold flex-shrink-0">:</div>}
            </>
          ))}
        </div>

        <div className="flex justify-center w-full px-6">
          <button
            onClick={onOpenModal}
            className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-4 sm:px-10 sm:py-5 rounded-full text-sm sm:text-lg font-bold uppercase shadow-2xl hover:scale-105 hover:shadow-green-500/50 transition-all duration-300 animate-pulse cursor-pointer w-full sm:w-auto max-w-[320px] sm:max-w-none"
          >
            <span className="whitespace-nowrap">👉 RESERVAR MI CUPO</span>
            <span className="whitespace-nowrap">PARA LA CLASE EN VIVO <i className="ri-arrow-right-line text-sm sm:text-xl"></i></span>
          </button>
        </div>

        <p className="text-gray-400 text-xs sm:text-sm mt-3">
          Acceso 100% gratuito — Cupos limitados
        </p>
      </div>
    </section>
  );
}
